import { ReactElement, useEffect } from 'react';
import { useHistory, useParams } from 'react-router';
import { Scratchpad, ScratchpadApp } from '../../api/graphql/generated';
import { MachineAuthorizationProvider } from '../../components/machine/machine-authorization-provider';
import { ScratchpadServiceContextProvider } from '../../components/machine/scratchpad/scratchpad-service-context-provider';
import { useBeaconRouter } from '../../route/route.hooks';
import { ScratchpadPageMappings } from '../../scratchpad/app-slugs';
import { ApplicationSupportProvider } from './application-support-context';
import { MachineContextProvider } from './machine-context-provider';

interface RouteParams {
  machineId: string;
  id: string;
}

interface MachineScratchpadPageProps {
  teamId: string;
}

interface MachineScratchpadPageState {
  app: ScratchpadApp;
}

const MachineScratchpadPage = (
  props: MachineScratchpadPageProps
): ReactElement => {
  const params = useParams<RouteParams>();
  const history = useHistory<MachineScratchpadPageState>();

  const {
    location: { state },
    replace,
  } = history;

  const { teamId } = props;
  const { id, machineId } = params;
  const { builder } = useBeaconRouter();

  useEffect(() => {
    if (state?.app === undefined && id === 'new') {
      replace(builder.getMachineRoute(teamId, machineId));
    }
  }, [state?.app, replace, builder, teamId, machineId, id]);

  const scratchpadId = id === 'new' ? undefined : id;

  return (
    <MachineContextProvider machineId={machineId} teamId={teamId}>
      <MachineAuthorizationProvider machineId={machineId} teamId={teamId}>
        <ScratchpadServiceContextProvider
          scratchpadId={scratchpadId}
          app={state?.app}
        >
          {(props: { scratchpad: Scratchpad }) => {
            const { scratchpad } = props;

            const AppPage = ScratchpadPageMappings[props.scratchpad?.app?.slug];

            if (AppPage) {
              return (
                <ApplicationSupportProvider>
                  <AppPage
                    teamId={teamId}
                    machineId={machineId}
                    scratchpad={scratchpad}
                  />
                </ApplicationSupportProvider>
              );
            }

            return <></>;
          }}
        </ScratchpadServiceContextProvider>
      </MachineAuthorizationProvider>
    </MachineContextProvider>
  );
};

export { MachineScratchpadPage };
